var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 53,
    viewBox: "0 0 57 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.45 47.3947H37.9182C38.3893 47.4061 38.8719 47.3947 39.343 47.3398C41.6986 47.3398 46.4944 46.9007 49.3326 43.6371C51.5235 41.0734 52.061 37.4714 50.9106 32.7922C47.0547 17.3802 36.3104 11.7176 35.8507 11.4889C35.7638 11.434 35.6541 11.4111 35.5557 11.4111H25.6439C25.5455 11.4111 25.4358 11.434 25.3489 11.4889C21.5959 14.3614 14.2569 20.8793 11.0231 31.603C10.0557 34.8116 9.63722 37.7962 9.5 40.3759",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6915 11.4141H35.5485L41.2774 3.02316C40.7079 2.30047 39.2511 0.811636 37.6091 1.01975C36.3489 1.21643 35.1231 1.54576 33.9499 2.01688C32.8864 2.47657 31.7704 2.76244 30.62 2.86078C29.4696 2.75101 28.3536 2.46742 27.2901 2.01688C26.1078 1.54576 24.8796 1.20729 23.6309 1.01975C22.0095 0.823071 20.5206 2.30047 19.9512 3.02316L25.6915 11.4141Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2584 38.4224L30.2772 37.1242C28.9239 37.0504 27.5892 36.7118 26.644 36.2816C26.3064 36.1276 26.1388 35.744 26.2416 35.3876L26.5891 34.183C26.716 33.7406 27.2021 33.5182 27.6241 33.7019C28.5616 34.1113 29.7224 34.4407 30.9787 34.4592C32.2825 34.4776 33.2617 34.0494 33.2743 33.1428C33.2861 32.3256 32.5419 31.8284 30.7362 31.3161C28.1606 30.5721 26.3198 29.4179 26.3526 27.1413C26.3819 25.0855 27.9074 23.5379 30.5215 23.1555L30.5405 21.8567C30.546 21.4387 30.8898 21.1046 31.3076 21.1107L32.0707 21.1215C32.4892 21.1278 32.8226 21.4714 32.8165 21.8893L32.8005 23.0553C34.0521 23.1234 34.9611 23.351 35.6811 23.6153C36.0501 23.7508 36.2468 24.153 36.1391 24.5314L35.8196 25.6455C35.6962 26.0759 35.2315 26.3051 34.8156 26.141C34.1534 25.8795 33.2149 25.6035 31.9899 25.5864C30.4428 25.5637 29.9914 26.1983 29.9836 26.7735C29.9732 27.4801 30.8943 27.9799 32.8968 28.6278C35.7582 29.531 36.9343 30.7419 36.9039 32.8856C36.8758 34.8528 35.3916 36.6003 32.5556 37.0018L32.5351 38.4552C32.5289 38.873 32.1851 39.2071 31.7673 39.2009L31.0042 39.1902C30.5864 39.1841 30.2523 38.8402 30.2584 38.4224Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 4L2 51",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 2L2 49",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimage);
export default __webpack_public_path__ + "static/media/noimage.cf4595ecdb23a9556ed3f11dad10908b.svg";
export { ForwardRef as ReactComponent };